export default [
    {
        path: '/ref-padre-cot',
        component: resolve => require(['./../index.vue'], resolve),
        children: [
            {
                path: '/ref-padre-cot/:cotParam',
                component: resolve => require(['../views/product_parent_cot/index.vue'], resolve),
                meta: {
                    title: 'Cot',
                    // permission: 'Cot'
                }
            },
        ]
    }
];



// WEBPACK FOOTER //
// ./src/product_parent_cot/router/index.js